module.exports = __webpack_public_path__ + "img/color1.ee6559fa.png";